import { useContext, useEffect, useRef } from "react";
import { AuthContext, IAuthContext } from "react-oauth2-code-pkce";
import portalApiClient from "../portal-api";

export default function Logout() {
  const { logOut }: IAuthContext = useContext(AuthContext);
  // logOut() mutates AuthContext, causing a re-render with a new logOut
  // reference; without this guard the effect would fire multiple times.
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;

    logOut();
    portalApiClient
      .post("/api/auth/logout/")
      .finally(() => window.location.assign("/"));
  }, [logOut]);

  return null;
}
